module.exports = __webpack_public_path__ + "img/portrait.c73cdb5a.png";